import { TRIAL_DAYS } from "../../../constants/trial";
import { LANDING_PRICE_FROM } from "../../Clinic/HomeLanding/landingSeo";
import L from "../../../constants/baysportLabels";

/**
 * Статический блог (без CMS). Посты — отдельные URL /blog/:slug для SEO.
 * Позже можно заменить на API, не меняя маршруты.
 */
export const BLOG_POSTS = [
  {
    slug: "zhurnal-poseshchaemosti-vmesto-tetradi",
    title: "Электронный журнал посещаемости вместо тетради",
    description:
      "Как секции уходят от бумажной переклички: отметки с телефона, списание абонемента и кабинет родителя.",
    date: "2026-09-18",
    tags: ["журнал", "посещаемость"],
    lead:
      "Тетрадь в зале работает, пока группа маленькая. Как только появляются должники, замены и вопросы родителей — нужен журнал, который связан с абонементами.",
    sections: [
      {
        h2: "Что ломается в бумажном учёте",
        paragraphs: [
          "Вечером после тренировок тренер переносит отметки в Excel. Родители пишут в чат: «Ребёнок был?» Администратор сверяет оплаты вручную. Ошибки копируются каждую неделю.",
          "Электронный журнал закрывает эту цепочку в момент отметки: занятие сразу влияет на остаток абонемента.",
        ],
      },
      {
        h2: "Как выглядит процесс в зале",
        paragraphs: [
          "Открыли занятие на телефоне, отметили состав — готово. Не нужно отдельно обновлять таблицу оплат.",
        ],
        bullets: [
          "Список группы на конкретную тренировку",
          "Отметка за несколько секунд",
          "История посещений по ученику",
        ],
      },
      {
        h2: "С чего начать",
        paragraphs: [
          `В ${L.productName} журнал есть на всех тарифах. Первые ${TRIAL_DAYS} дней — полный доступ, от ${LANDING_PRICE_FROM} ₽/мес после триала.`,
        ],
      },
    ],
  },
  {
    slug: "kak-vesti-abonementy-sportivnoj-sekcii",
    title: "Как вести абонементы спортивной секции без Excel",
    description:
      "Типы абонементов, списание занятий, должники и онлайн-оплата своими ключами клуба.",
    date: "2026-09-25",
    tags: ["абонементы", "оплаты"],
    lead:
      "Абонементы — главный денежный контур секции. Если остатки и должники живут в таблице, продления всегда «догоняют» вручную.",
    sections: [
      {
        h2: "Какие типы абонементов обычно нужны",
        paragraphs: [
          "Пакет занятий (8/12), период (месяц), пробный. Иногда — заморозка. Важно, чтобы списание шло из журнала, а не отдельной кнопкой «вечером».",
        ],
      },
      {
        h2: "Должники в одном списке",
        paragraphs: [
          "Владельцу нужна не ещё одна таблица, а ответ: кто не оплатил и на какую сумму. Тогда напоминания перестают быть хаосом в WhatsApp.",
        ],
      },
      {
        h2: "Онлайн-оплата",
        paragraphs: [
          "Родитель платит в кабинете секции. Деньги идут на ключи клуба — без посредника-разработчика.",
        ],
      },
    ],
  },
  {
    slug: "prilozhenie-dlya-kluba-bez-razrabotchika",
    title: "Приложение для спортивного клуба без разработчика",
    description:
      "PWA под брендом клуба: кабинет родителей, расписание и посещения без публикации в App Store.",
    date: "2026-10-02",
    tags: ["PWA", "приложение"],
    lead:
      "Заказ нативного приложения стоит дорого и долго. Для секции чаще достаточно PWA: страница клуба на главном экране телефона под вашим логотипом.",
    sections: [
      {
        h2: "Что видит родитель",
        bullets: [
          "Расписание секции",
          "Посещения ребёнка",
          "Остаток абонемента",
          "Объявления клуба",
        ],
        paragraphs: [
          "Отдельный магазин приложений не нужен: браузер + «На экран Домой».",
        ],
      },
      {
        h2: "Зачем брендинг",
        paragraphs: [
          "Родители должны чувствовать, что это приложение вашей школы, а не чужого сервиса. В тарифах Бай.Спорт есть оформление портала и splash под клуб.",
        ],
      },
    ],
  },
  {
    slug: "crm-dlya-trenera-s-odnoj-gruppoj",
    title: "CRM для тренера с одной группой: с чего начать",
    description:
      "Минимальный контур для соло-тренера: ученики, журнал, абонементы и кабинет родителей.",
    date: "2026-10-08",
    tags: ["тренер", "crm"],
    lead:
      "Не обязательно внедрять «большую CRM». Одному тренеру достаточно контура: кто ходит, кто оплатил, что видит родитель.",
    sections: [
      {
        h2: "Порядок запуска за вечер",
        bullets: [
          "Создать секцию и группу",
          "Добавить учеников (или дать ссылку родителям)",
          "Завести типы абонементов",
          "Отметить ближайшую тренировку",
        ],
        paragraphs: [
          `Такой порядок обычно закрывает 80% боли Excel и чатов. В ${L.productName} старт — от ${LANDING_PRICE_FROM} ₽/мес после ${TRIAL_DAYS} дней триала.`,
        ],
      },
    ],
  },
];

export function getBlogPost(slug) {
  return BLOG_POSTS.find((p) => p.slug === slug) || null;
}

export function listBlogPosts() {
  return [...BLOG_POSTS].sort((a, b) => String(b.date).localeCompare(String(a.date)));
}
